/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
    return (
        <footer className="footer">
            <Container fluid>
                <Nav>
                    <NavItem>
                        <NavLink href="https://themoviehouse.tv/tmh/#/privacy-policy/">
                            Privacy
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="https://themoviehouse.tv/tmh/#/terms-conditions/">
                            Terms & Conditions
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="https://themoviehouse.tv/tmh/#/about/">
                            About Us
                        </NavLink>
                    </NavItem>
                </Nav>
            </Container>
        </footer>
    );
}

export default Footer;
